module.exports = __webpack_public_path__ + "static/media/0075_Medium.08da7673.jpg";